module.exports = __webpack_public_path__ + "static/img/H3.72b5e9c9.jpg";